module.exports = __webpack_public_path__ + "img/box.310d8273.svg";